module.exports = __webpack_public_path__ + "img/tiktok.7030fdb.png";